import React from 'react';
import { MainContactResearch } from './MainContactResearch';

export const ResponsiveResearch = () => {
  return <MainContactResearch />;
};
